<template>
  <div
    class="skeleton-loader-container"
    :style="{ width: width, height: height }"
  >
    <div class="skeleton-loader-bar"></div>
  </div>
</template>

<script>
export default {
  name: "SkeletonLoader",
  props: {
    height: {
      type: String,
      default: "48px",
    },
    width: {
      type: String,
      default: "100%",
    },
  },
};
</script>

<style lang="scss" scoped>
.skeleton-loader-container {
  overflow: hidden;
  opacity: 0.3;
  background-color: #d9d9d9;
  border-radius: 5px;
}

.skeleton-loader-bar {
  height: 100%;
  background-color: rgb(0 0 0 / 35%);
  border-radius: 0;
  animation: load 10s linear infinite;
}

@keyframes load {
  0% {
    width: 0;
    opacity: 0;
    border-radius: 0.5px;
  }

  20% {
    width: 100%;
    opacity: 1;
  }

  25% {
    border-radius: 10px;
  }

  40% {
    opacity: 0;
  }

  60% {
    opacity: 1;
  }

  80% {
    opacity: 0;
  }

  100% {
    width: 100%;
  }
}
</style>
